import { Component, Inject, OnInit, OnDestroy } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { CommonService } from "src/app/Service/Common.service";
import { Module } from "src/app/Service/element-details.data.service";
import { NotificationService } from "src/app/Service/notification.service";
import { ProjectInfoService } from "src/app/Service/project-info/project-info.service";
import { ScheduleDocumentService } from "src/app/Service/scheduledocument/scheduleDocument.service";
import { IProjectElementDetailsOutput, IProjectElementsOutput } from "src/app/ViewModel/ProjectElementsModel";
import { IRevisionCategory, IScheduleDocInfo, ILatestStageDetails, IDCIPostBulkSupersedeModel } from "src/app/ViewModel/ScheduleDocumentModel";
import { WorkflowTemplateModel } from 'src/app/ViewModel/WorkflowTemplateModel';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';
import { DatePipe } from "@angular/common";
import { ElementdetailsService } from "src/app/Service/elementdetails/elementdetails.service";
import { ICCNListInputModel, ICCNWorkflowModel } from "src/app/ViewModel/CCNModel";
import { CcnService } from "src/app/Service/ccn/ccn.service";
import { LoaderService } from "src/app/Service/Loader/loader.service";
import { Subscription } from "rxjs";
import { isNumber } from 'lodash';
@Component({
    selector: 'app-dci-supersede',
    templateUrl: './dci-supersede.component.html',
    styles: [`
        ::ng-deep .child-mat-expan.mat-expansion-panel {
            margin: 0 0px !important;
        }
    `]
})
export class DciSupersedeComponent implements OnInit, OnDestroy {
    subscriptions: Subscription[] = []
    projectId!: number;
    groupId!: number;
    memberId!: number;
    revForm!: FormGroup;
    ccnForm!: FormGroup;
    revCategoryList: IRevisionCategory[] = [{ revCategoryId: 1, revCategory: 'Minor' }, { revCategoryId: 2, revCategory: 'Major' }, { revCategoryId: 3, revCategory: 'First Release' }];
    printSizeList: IProjectElementDetailsOutput[] = [];
    selectedPrintSize!: number;
    dciStatusList: IProjectElementDetailsOutput[] = [];
    selectedDciStatus!: number;
    workflowList: WorkflowTemplateModel[] = [];
    selectedWorkflow!: number;
    projectStaticElements: IProjectElementsOutput[] = [];
    isDocSetRequired: boolean = true;
    LatestStageDetails: ILatestStageDetails[] = [];
    DocNo: string;
    panelOpenState = true;
    selectedschtype!: number;

    ccnTypeList: any[] = [];
    categoryList: any[] = [{ revCategoryId: 1, revCategory: 'For Approval(A)' }, { revCategoryId: 2, revCategory: 'Good For Construction(GFC)' }];
    ccnList: ICCNWorkflowModel[];
    IsCCNRequired: boolean = false;

    constructor(private _commonService: CommonService, public _dialogRef: MatDialogRef<DciSupersedeComponent>, private _notificationService: NotificationService, private _formBuilder: FormBuilder, private _projService: ProjectInfoService, private _scheduleDocService: ScheduleDocumentService, @Inject(MAT_DIALOG_DATA) public _data: IScheduleDocInfo, private dialog: MatDialog, public workflowTemplateService: WorkflowTemplateService, public _datepipe: DatePipe, private elementdetailsService: ElementdetailsService, private ccnService: CcnService, private loaderService: LoaderService) {

    }

    ngOnInit(): void {
        this.projectId = this._commonService.getProjectId();
        this.groupId = this._commonService.getLoggedInUserGroupId();
        this.memberId = this._commonService.getLoggedInUserId();
        this.initializeForm();
        this.getElementDetails("Print Size");
        this.getElementDetails("Status");
        this.getWorkflowDetails();
        this.getProjectStaticElements();
        this.GetLatestStageDetails();
        this.getCCNTypeList();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    initializeForm() {
        this.DocNo = this._data.doc_No + " ( " + this._data.revision_No + " ) ";
        let revision_No 
        // = this._data.revision_No.substring(0, this._data.revision_No.length - 1) +
        //     String.fromCharCode(this._data.revision_No.charCodeAt(this._data.revision_No.length - 1) + 1);
            if(!isNaN(Number(this._data.revision_No)))
            {
                 revision_No = String(Number(this._data.revision_No)+ 1);        
            }
            else{
             revision_No = this._data.revision_No.substring(0, this._data.revision_No.length - 1) +
                String.fromCharCode(this._data.revision_No.charCodeAt(this._data.revision_No.length - 1) + 1);
            }
        this.revForm = this._formBuilder.group({
            printSize: new FormControl('', Validators.required),
            formPrintSize: new FormControl('', Validators.required),
            revCategory: new FormControl('', Validators.required),
            formrevCategory: new FormControl('', Validators.required),
            dciStatus: new FormControl('', [Validators.required]),
            formDciStatus: new FormControl('', [Validators.required]),
            noOfSheets: new FormControl(0),
            comments: new FormControl(),
            formWorkflow: new FormControl('', [Validators.required]),
            formRevision: new FormControl(revision_No, [Validators.required])
        });

        this.ccnForm = this._formBuilder.group({
            CCNType: new FormControl('', Validators.required),
            formCCNType: new FormControl('', Validators.required),
            CCN: new FormControl('', Validators.required),
            formCCN: new FormControl('', Validators.required),
            Category: new FormControl('', Validators.required),
            formCategory: new FormControl('', Validators.required),
            formDraftingManHrs: new FormControl(0, Validators.required).setValue(0),
            formDesignManHrs: new FormControl(0, Validators.required).setValue(0),
        })

        if (!!this._data.revision_Category) {
            let revisionCategory = this.revCategoryList.filter(data => data.revCategoryId == this._data.revision_Category)[0];
            this.revForm.get('formrevCategory')?.setValue(revisionCategory.revCategory);
            this.revForm.get('revCategory')?.setValue(revisionCategory);
        }
    }

    GetLatestStageDetails() {
        let obj = {
            "Doc_Id": this._data.doc_Id,
            "Stage_Ids": (this._data.current_Stage != null && this._data.current_Stage != '' && this._data.is_WF_Started) ? this._data.dciScheduleStageDetails.filter((x, y) => x.stage_Short_Desc == this._data.current_Stage).map(k => k.stage_Id).join(',') : this._data.dciScheduleStageDetails.map(k => k.stage_Id).join(',')
        }

        this.subscriptions.push(this.workflowTemplateService.GetWorkflowLatestStageDetail(obj).subscribe(data => {
            if (!!data) {
                this.LatestStageDetails = data.map((x: { scheduled_On: string | number | Date; revisedScheduled_On: string | number | Date | null; minScheduled_On: string | number | Date | null; maxScheduled_On: string | number | Date | null; }) => { x.scheduled_On = new Date(x.scheduled_On), x.revisedScheduled_On = (x.revisedScheduled_On ? new Date(x.revisedScheduled_On) : null), x.minScheduled_On = (x.minScheduled_On ? new Date(x.minScheduled_On) : null), x.maxScheduled_On = (x.maxScheduled_On ? new Date(x.maxScheduled_On) : null); return x });
            }
        }));
    }

    collapseAllClick() {
        this.panelOpenState = !this.panelOpenState;
    }

    /**
* Get Element Details (Print Size,Doc Status)
*/
    public getElementDetails(elementName: string) {
        this.subscriptions.push(this._projService.getProjectElementDetails({ projectId: this._commonService.getProjectId(), groupId: this._commonService.getLoggedInUserGroupId(), moduleId: Module.ScheduleDocument, deDescription: elementName })
            .subscribe((res: IProjectElementDetailsOutput[]) => {
                switch (elementName) {
                    case "Print Size":
                        this.printSizeList = res;
                        if (!!this._data.print_Size_Id) {
                            let printSize = this.printSizeList.filter(data => data.dedId == this._data.print_Size_Id)[0];
                            this.revForm.get('formPrintSize')?.setValue(printSize.dedDescription);
                            this.revForm.get('printSize')?.setValue(printSize);
                        }
                        break;
                    case "Status":
                        this.dciStatusList = res;
                        if (!!this._data.doc_Status_Id) {
                            let status = this.dciStatusList.filter(data => data.dedId == this._data.doc_Status_Id)[0];
                            this.revForm.get('formDciStatus')?.setValue(status.dedDescription);
                            this.revForm.get('dciStatus')?.setValue(status);
                        }
                        break;
                }
            }, err => { }));
    }

    getWorkflowDetails() {
        if (this._data.schedule_Type)
            this.selectedschtype = this._data.schedule_Type;
        this.subscriptions.push(this._scheduleDocService.GetWorkflowList().subscribe((x: WorkflowTemplateModel[]) => {
            this.workflowList = x.filter(y => y.isForsupersede);
            this.workflowList = this.workflowList.filter(x => x.scheduleType == this.selectedschtype);
            if (this._data.workflow_Id != null && this._data.workflow_Id > 0) {
                this.selectedWorkflow = this._data.workflow_Id;
                this.setFormValue(this.revForm, "formWorkflow", this.selectedWorkflow);
            }
        }));
    }

    setFormValue(form: FormGroup, formControlName: string, value: any) {
        form.get(formControlName)?.setValue(value);
    }

    async onselectedValueChange(val: any, formGroupName: string, formControlName: string) {
        switch (formGroupName) {
            case "revForm":
                if (formControlName == "workflow") {
                    this.selectedWorkflow = val.value;
                    this.IsCCNRequired = val.additionalValues.additionalValues.cnN_Required;
                }
                this.revForm.get(formControlName)?.setValue(val.additionalValues.additionalValues);
                break;
            case "ccnForm":
                if (formControlName == "CCNType") {
                    let ccnInput: ICCNListInputModel = {
                        projectId: this.projectId,
                        cCType: val.value,
                        createdFromDays: 0
                    };

                    let res: any[] = await this.ccnService.GetCCNList(ccnInput).toPromise();
                    this.ccnList = res.filter(x => x.publishDate != null);
                }

                if (formControlName == "formDraftingManHrs" || formControlName == "formDesignManHrs")
                    this.ccnForm.get(formControlName)?.setValue(val.srcElement.value);
                else
                    this.ccnForm.get(formControlName)?.setValue(val.additionalValues.additionalValues);
                break;
        }
    }

    /**
  * Close modal dialog
  */
    closeDialog() {
        this._dialogRef.close();
    }

    async getProjectStaticElements() {
        await this._projService.getProjectElements({ projectId: this._commonService.getProjectId(), groupId: this._commonService.getLoggedInUserGroupId(), moduleId: Module.ScheduleDocument, IsQueryForStaticElement: true }).toPromise().then(
            (res: IProjectElementsOutput[]) => {
                if (res.length > 0) {
                    this.projectStaticElements = res;
                    let isDocSetRequiredElement = this.projectStaticElements.filter(x => x.elementDescription == "IsDocSetRequired")[0];
                    if (!!isDocSetRequiredElement) {
                        this.isDocSetRequired = isDocSetRequiredElement.isMandatory;
                    }
                }
            }, err => {
                this._notificationService.showToast("failed to get static element details", "Warning");
            });
    }

    setStageDate(selectedStageDate: any, stage: ILatestStageDetails) {
        stage.scheduled_On = selectedStageDate.value;
        stage.updatedScheduled_On = selectedStageDate.value;
    }

    public async getCCNTypeList() {
        let x = await this.elementdetailsService.GetElementDetailsByDescList('CCN Type').toPromise();
        if (x && x.length > 0) {
            this.ccnTypeList = x;
        }
    }

    saveSuperdeDetails() {
        this.loaderService.isLoading.next(true);
        let DCISupersedeDetails: IDCIPostBulkSupersedeModel[] = [{
            index: 0,
            doc_Id: this._data.doc_Id,
            doc_No: this._data.doc_No,
            doc_Title: this._data.doc_Title,
            current_Stage: this._data.current_Stage,
            current_StageId: this._data.current_StageId,
            revision_No: this._data.revision_No,
            supersede_Revision_No: this.revForm.get('formRevision')?.value,
            revision_Category: this.revForm.get('revCategory')?.value.revCategoryId,
            released_For: this.revForm.get('dciStatus')?.value.dedId,
            print_Size: this.revForm.get('printSize')?.value.dedId,
            schedule_Type: this._data.schedule_Type,
            parentWorkflow: this._data.workflow_Id,
            workflow: this.selectedWorkflow,
            noOfSheets: this.revForm.get('noOfSheets')?.value ? this.revForm.get('noOfSheets')?.value : 0,
            dciScheduleStageDetails: this._data.dciScheduleStageDetails,
            comments: this.revForm.get('comments')?.value,
            ccnTypeDetails: this.ccnList ? this.ccnList : null,
            ccnType: this.ccnForm.get('CCNType')?.value.deD_Id ? this.ccnForm.get('CCNType')?.value.deD_Id : null,
            tagCCN: this.ccnForm.get('CCN')?.value.ccnId ? this.ccnForm.get('CCN')?.value.ccnId : null,
            category: this.ccnForm.get('Category')?.value.revCategoryId ? this.ccnForm.get('Category')?.value.revCategoryId : null,
            draftingManHours: this.ccnForm.get('formDraftingManHrs')?.value,
            designManHours: this.ccnForm.get('formDesignManHrs')?.value,
            latestStageDetails: this.LatestStageDetails.map(x => { x.scheduled_On = this._datepipe.transform(x.scheduled_On, 'dd-MMM-yyyy'), x.revisedScheduled_On = (x.revisedScheduled_On ? this._datepipe.transform(x.revisedScheduled_On, 'dd-MMM-yyyy') : null), x.minScheduled_On = (x.minScheduled_On ? this._datepipe.transform(x.minScheduled_On, 'dd-MMM-yyyy') : null), x.maxScheduled_On = (x.maxScheduled_On ? this._datepipe.transform(x.maxScheduled_On, 'dd-MMM-yyyy') : null); return x }),
            is_WF_Started: this._data.is_WF_Started,
            isCCNActive: this.IsCCNRequired,
        }]

        this.subscriptions.push(this._scheduleDocService.PostBulkDCISupersede(DCISupersedeDetails).subscribe((res: any) => {
            this.loaderService.isLoading.next(false);

            if (res.length > 0) {
                if (res[0].status)
                    this._notificationService.showPopup('DCI Superseded Successfully!!!', "Success");
                else
                    this._notificationService.showPopup('Failed to Supersede DCI!!!', "Warning");

                this._dialogRef.close();
            }
            else {
                this._notificationService.showPopup("Failed to Supersede DCI", "Warning");
                this._dialogRef.close();
            }

        }, err => {
            this.loaderService.isLoading.next(false);
            this._notificationService.showToast(err, "Error");
            this._dialogRef.close();
        }));
    }
}